// extracted by mini-css-extract-plugin
export default {"popup":"Popup_popup__Eu1uv","popup_inner":"Popup_popup_inner__Zyjsn","close_btn":"Popup_close_btn__hxdyy"};